export default __webpack_public_path__ + "static/media/icons-05.873f0f75.svg";